module.exports = __webpack_public_path__ + "media/A0102.ca869453.mp4";